export function debounce(callback, wait, immediate = false, context = this) {
    let timeout = null,
        callbackArgs = null;

    const later = () => {
        timeout = null;
        if (!immediate) {
            callback.apply(context, callbackArgs);
        }
    };

    return function() {
        const callNow = immediate && !timeout;
        clearTimeout(timeout);
        callbackArgs = arguments;
        timeout = setTimeout(later, wait);
        if (callNow) {
            callback.apply(context, callbackArgs);
        }
    }
}

export function inView(node, offset = 0) {
    let nodeRect = node.getBoundingClientRect(),
        inView = false,
        consoleDebug = false,
        debug = [],
        maxHeight = window.innerHeight + offset;
    if (nodeRect.top > offset && nodeRect.top < maxHeight) {
        inView = true;
        debug.push(`top`);
    }
    if (nodeRect.bottom > offset && nodeRect.bottom < maxHeight) {
        inView = true;
        debug.push(`bottom`);
    }
    if (nodeRect.bottom > maxHeight && nodeRect.top < offset) {
        inView = true;
        debug.push(`large`);
    }
    debug.push(`[top: ${nodeRect.top}, bottom: ${nodeRect.bottom}, maxHeight: ${maxHeight}]`);
    if (consoleDebug) {
        console.log(debug);
    }
    return  inView;
}

export function getMobileOS() {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
        return "Windows Phone";
    }

    if (/android/i.test(userAgent)) {
        return "Android";
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return "iOS";
    }

    return "unknown";
}



// WEBPACK FOOTER //
// ./app/themes/template/res/js/src/modules/Utils.js